module Meevo.Components.Controls {
    declare let d3: any;

    class MeevoGoalsDonutChartComponent implements angular.IComponentController {

        static $inject = ['$scope'];
        public goalDecimal: number;
        public actualDecimal: number;
        public chartClass: string;
        public parent: any;
        public goal: number;
        public actual: number;

        constructor(private $scope: ng.IScope) { }


        $onInit = () => {

            let chartClass: string = '.'.concat(this.chartClass);
            this.goalDecimal = this.parent.goal;
            this.actualDecimal = this.parent.actual;


        }

        createDonutChart(numGoal: number, numActual: number, id: string) {
            // console.log('creatdonutchart() ran', d3.select(id));
            // console.log(id);
            let width: number = 200;
            let height: number = 200;
            let thickness: number = 40;
            let duration: number = 1000;
            let foregroundColor: string = "#72b8ff";

            let backgroundColor: string = "#e2e0e0";
            let percent: number = numActual;
            let radius: number = Math.min(width, height) / 2;
            var color = d3.scaleOrdinal([foregroundColor, backgroundColor]);

            //var svg = d3.select(id)
            const svg = d3.select(id)
                .append('svg')
                .attr('class', 'pie')
                .attr('width', width)
                .attr('height', height);

            var g = svg.append('g')
                .attr('transform', 'translate(' + (width / 2) + ',' + (height / 2) + ')');

            var arc = d3.arc()
                .innerRadius(radius - thickness)
                .outerRadius(radius);

            var pie = d3.pie()
                .padAngle(0.03)
                .sort(null);

            var path = g.selectAll('path')
                .data(pie([0, 1]))
                .enter()
                .append('path')
                .attr('d', arc)
                .attr('fill', function (d, i) {
                    return color(i);
                })
                .each(function (d) { this._current = d; });


            path.data(pie([percent, 1 - percent])).transition()
                .duration(duration)
                .attrTween('d', function (d) {
                    var interpolate = d3.interpolate(this._current, d);
                    this._current = interpolate(0);
                    return function (t) {
                        return arc(interpolate(t));
                    }
                });
        }


        createBarChart = (numGoal: number, numActual: number, id: string) => {
            console.log('inside createBarChart', numGoal, numActual)
            let width: number = 200;
            let height: number = 200;
            let thickness: number = 40;
            let duration: number = 1000;
            let foregroundColor: string = "#72b8ff";
            let backgroundColor: string = "#ccc";
            let percent: number = numActual;
            let margin = {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
            };
            let groupBarPadding = .2;
            let individualBarPadding = 4;
            var color = d3.scaleOrdinal([backgroundColor, foregroundColor]);

            const categories = ['goals', 'actuals'];

            let data = [
                {
                    subCategory: 'goals',
                    value: numGoal,
                },
                {
                    subCategory: 'actual',
                    value: numActual,
                }
            ];

            const svg = d3.select(id);
            if (d3.select(id).select('svg').empty()) {
                svg.append('svg')
                    .attr('class', 'bar-chart')
                    .attr('preserveAspectRatio', 'xMinYMin meet')
                    .attr('width', width)
                    .attr('height', height)
                    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
            }
            else {
                svg.selectAll('*').remove();

                svg.attr('class', 'bar-chart')
                    .attr('preserveAspectRatio', 'xMinYMin meet')
                    .attr('width', width)
                    .attr('height', height)
                    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
            }

            const x = d3.scaleBand().rangeRound([0, width]).padding(groupBarPadding);
            const y = d3.scaleLinear().rangeRound([height, 0]);

            const xAxis = d3.axisBottom(x)
                .tickValues([])
                .tickSize(0);

            // Chart placement
            svg.attr('width', width)
                .attr('height', height)
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')


            x.domain(data.map(function (d) { return d.subCategory; }));

            y.domain([0, d3.max(data, function (d) { return d.value; })]);

            // Draw x-axis
            svg.append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0, ' + height + ')')
                .call(xAxis)
                .selectAll('text')
                .attr('class', 'svg-category-label')

            // Hide label
            svg.selectAll('.svg-category-label')
                .attr('display', 'none')

            // Chart
            svg.selectAll('rect')
                .data(data)
                .enter().append('rect')
                .attr('class', 'bar')
                .attr('x', function (d) { return x(d.subCategory) })
                .attr('y', function (d) { return y(0) })
                .attr('width', x.bandwidth())
                .attr('height', function (d) { return height - y(0) })
                .attr('fill', d => color(d.subCategory))

            // Transition animation
            svg.selectAll('rect')
                .transition()
                .delay(200)
                .duration(1000)
                .attr('y', function (d) { return y(d.value) })
                .attr('height', function (d) { return height - y(d.value) });

        }
    }


    angular.module('meevo.components.controls')
        .component('meevoGoalsDonutChartComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/charts/goalsDonutChart/goalsDonutChart.template.html',
            controller: MeevoGoalsDonutChartComponent,
            controllerAs: 'vm',
            bindings: {
                chartClass: '@',
                goal: '<',
                actual: '<',
                mapFn: '='
            },
            require: {
                parent: '^^meevoGoalsTileComponent'
            }
        });
}